export default "__VITE_ASSET__Drn27jUm__"